<div class="w-full align-middle inline-flex justify-between">
    <img class="other-payment-options" src="assets/icons/Icons/other-payment-options/visa_click-to-pay.png" alt="visa click to pay">
    <div class="grid grid-cols-1 float-right">
        <mat-icon class="new-window">keyboard_arrow_right</mat-icon>
        <mat-icon class="cursor-pointer" (click)="toggleListView()">info</mat-icon>
    </div>
</div>